import { createSlice } from '@reduxjs/toolkit';
import {
  fetchEmployees,
  fetchEmployeeCode,
  fetchDepartments,
  fetchDesignations,
  saveEmployee,
  saveEmployeeUser,
  removeEmployee,
  fetchAttendanceSummary,
  fetchEmployeeMonthlyPayDetails,
  fetchEmployeeUsers,
  fetchMapEmployeeUsers, 
  fetchClients,
  fetchClientUsers,
  fetchHrLocations,
  fetchEmailSchedules,
  fetchAllBranchUsers,
} from './employeeThunks';

const initialState = {
  list: [],
  departments: [],
  designations: [],
  clients: [],
  clientReportingManagers: [],
  emailSchedulesData: [],
  hrLocations: [],
  employeeUsers: [],
  allbranchUsers: [],
  mapEmployeeUsers: [],
  viewMode: false,
  code: null,
  loading: false,
  saving: false,
  error: null,
};

const employeesSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
    setViewMode(s){
      s.viewMode = true;
    },
    resetViewMode(s){
      s.viewMode = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // 🔹 Employees
      .addCase(fetchEmployees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🔹 Employee Code
      .addCase(fetchEmployeeCode.fulfilled, (state, action) => {
        state.code = action.payload;
      })

      // 🔹 Departments
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.departments = action.payload;
      })

      // 🔹 Designations
      .addCase(fetchDesignations.fulfilled, (state, action) => {
        state.designations = action.payload;
      })

      // 🔹 Clients
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.clients = action.payload;
      })
      
      // 🔹 ClientUsers
      .addCase(fetchClientUsers.fulfilled, (state, action) => {
        state.clientReportingManagers = action.payload;
      })

      // 🔹 EmailSchedules
      .addCase(fetchEmailSchedules.fulfilled, (state, action) => {
        state.emailSchedulesData = action.payload;
      })

      // 🔹 HR Locations
      .addCase(fetchHrLocations.fulfilled, (state, action) => {
        state.hrLocations = action.payload;
      })

      // 🔹 Employee Users
      .addCase(fetchEmployeeUsers.fulfilled, (state, action) => {
        state.employeeUsers = action.payload;
      })

      // 🔹 All Branch Users
      .addCase(fetchAllBranchUsers.fulfilled, (state, action) => {
        state.allbranchUsers = action.payload;
      })

      // 🔹 Employee Map Users
      .addCase(fetchMapEmployeeUsers.fulfilled, (state, action) => {
        state.mapEmployeeUsers = action.payload;
      })

      // 🔹 SaveEmployee / Mapuser
      .addCase(saveEmployee.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveEmployee.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(saveEmployee.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })


      // 🔹 Save Employee User (Enable Login Access)
      .addCase(saveEmployeeUser.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveEmployeeUser.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(saveEmployeeUser.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })

      // 🔹 Remove
      .addCase(removeEmployee.pending, (state) => {
        state.saving = true;
      })
      .addCase(removeEmployee.fulfilled, (state, action) => {
        state.saving = false;
        state.list = state.list.filter((e) => e.id !== action.payload.id);
      })
      .addCase(removeEmployee.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })

      // 🔹 Attendance summary and pay details (for FinalSettlement / Payslip)
      .addCase(fetchAttendanceSummary.fulfilled, (state, action) => {
        state.attendanceSummary = action.payload;
      })
      .addCase(fetchEmployeeMonthlyPayDetails.fulfilled, (state, action) => {
        state.monthlyPayDetails = action.payload;
      });
  },
});

export const { clearError, setViewMode, resetViewMode } = employeesSlice.actions;
export default employeesSlice.reducer;

// ✅ re-export thunks for import convenience
export {
  fetchEmployees,
  fetchEmployeeCode,
  fetchDepartments,
  fetchDesignations,
  fetchClients,
  fetchHrLocations,
  fetchEmployeeUsers,
  saveEmployee,
  removeEmployee,
  fetchAttendanceSummary,
  fetchEmployeeMonthlyPayDetails,
  fetchMapEmployeeUsers,
};
